module.exports = __webpack_public_path__ + "static/media/Comments.33cd3b85.svg";